import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { specials } from "../mock";
import FinanceApply from "./FinanceApply";

const SummerSpecials = () => {
  return (
    <section className="bg-brand-sand py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            Limited Time
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl">
            Seasonal Specials
          </h2>
          <div className="w-20 h-1 bg-brand-orange rounded-full mx-auto mt-4" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {specials.map((s, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl p-6 border border-black/5 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <span className="inline-block bg-brand-orange/10 text-brand-orangedark font-bold text-xs uppercase tracking-wide px-3 py-1.5 rounded-full mb-4">
                {s.badge}
              </span>
              <h3 className="font-display font-bold text-brand-navy text-lg leading-snug mb-2">
                {s.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-4">
                {s.desc}
              </p>
              {s.finance ? (
                <FinanceApply label={s.cta} />
              ) : s.href ? (
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangedark text-white font-semibold text-sm px-4 py-2.5 rounded-full shadow-md transition-all hover:-translate-y-0.5"
                >
                  {s.cta}
                  <ArrowRight className="w-4 h-4" />
                </a>
              ) : (
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-1.5 text-brand-orange font-semibold text-sm group-hover:gap-2.5 transition-all"
                >
                  {s.cta}
                  <ArrowRight className="w-4 h-4" />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SummerSpecials;
